import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";

const faqItems = [
  {
    id: 1,
    question: "Apa itu Jadipraktisi?",
    answer:
      "Jadipraktisi adalah platform persiapan karir dan peningkatan skill bagi mahasiswa dan profesional di Bidang Kesehatan. Jadipraktisi didukung dengan materi pembelajaran yang komprehensif dan mentor yang berkompeten dibidangnya.",
    show: true,
    delay: 0
  },
  {
    id: 2,
    question: "Apa saja program Jadipraktisi?",
    answer:
      "Jadipraktisi memiliki dua program utama: program individu Live Teaching Online melalui ZOOM / Offline dan Video E-Course belajar mandiri. Selain itu, terdapat juga program Kerjasama Corporate dan Campus yang semuanya di mentoring oleh para Experts dibidangnya.",
    show: false,
    delay: 250
  },
  {
    id: 3,
    question: "Apakah Jadipraktisi berbayar?",
    answer:
      "Kedua program utama Jadipraktisi (Live Teaching Online ZOOM / Offline, Video E-Course dan Kerjasama Corporate dan Campus) memiliki biaya yang affordable. Jadipraktisi juga memiliki program gratis seperti Praktisi Talk dan Video E-Course yang bisa kamu ikuti secara gratis.",
    show: false,
    delay: 250
  },
  {
    id: 4,
    question: "Platform pembayaran apa saja yang digunakan Jadipraktisi?",
    answer:
      "Pembayaran bisa menggunakan berbagai e-wallet, QRIS, transfer bank manual hingga melalui minimarket terdekat.",
    show: false,
    delay: 250
  },
  {
    id: 5,
    question:
      "Kemana saya mendapat informasi untuk kerjasama atau jika terdapat kendala?",
    answer: (
      <>
        Silahkan, kamu bisa menghubungi Jadipraktisi melalui{" "}
        <a
          href="https://linktr.ee/jadipraktisi"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#0d6efd", textDecoration: "underline" }}
        >
          linktr.ee/jadipraktisi
        </a>
        .
      </>
    ),
    show: false,
    delay: 250
  }
];


const Faq = () => {
  return (
    <>
      <div className="faq-section">
        <ImageWithBasePath
          src="assets/img/bg/bg-21.svg"
          alt="img"
          className="d-lg-flex d-none faq-bg2"
        />
        <ImageWithBasePath
          src="assets/img/bg/bg-22.svg"
          alt="img"
          className="d-lg-flex d-none faq-bg3"
        />

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="faq-content text-center">
                <div className="section-header" data-aos="fade-up">
                  <h2 className="mb-1">Pertanyaan yang Sering Ditanyakan</h2>
                  <p>
                    Temukan jawaban untuk berbagai pertanyaan yang sering di tanyakan di Jadipraktisi
                  </p>
                </div>

                <div
                  className="accordion accordion-customicon1 accordions-items-seperate"
                  id="accordioncustomicon1Example"
                >
                  {faqItems.map((item) => (
                    <div
                      className="accordion-item"
                      key={item.id}
                      data-aos="fade-up"
                      data-aos-delay={item.delay}
                    >
                      <h2 className="accordion-header" id={`heading${item.id}`}>
                        <Link
                          to="#"
                          className={`accordion-button ${item.show ? "" : "collapsed"
                            }`}
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${item.id}`}
                          aria-expanded={item.show}
                          aria-controls={`collapse${item.id}`}
                        >
                          {item.question}
                          <i className="isax isax-add fs-20 fw-semibold ms-1" />
                        </Link>
                      </h2>

                      <div
                        id={`collapse${item.id}`}
                        className={`accordion-collapse collapse ${item.show ? "show" : ""
                          }`}
                        aria-labelledby={`heading${item.id}`}
                        data-bs-parent="#accordioncustomicon1Example"
                      >
                        <div className="accordion-body pt-0">
                          <p style={{ textAlign: "left", color: '#1E344C' }}>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;